import React from "react";
import './Tweet.css'

export default function Tweet(props) {
  const { tweet } = props;
  return (
    <div className="tweet">
      <div className="header">
        <span>{tweet.userName}</span>
        <span>{tweet.date}</span>
      </div>
      <p>{tweet.content}</p>
    </div>
  );
}
